import { render, staticRenderFns } from "./editPromoCard.vue?vue&type=template&id=2b14a56f&scoped=true&"
import script from "./editPromoCard.vue?vue&type=script&lang=js&"
export * from "./editPromoCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b14a56f",
  null
  
)

export default component.exports